import SwitchAccountMain from '@/components/SwitchAccountMain'
const SwitchAccounts = () => {
    const element = (<><SwitchAccountMain /></>);
    return element
}
export default SwitchAccounts